export default __webpack_public_path__ + "static/media/fr.e99e98c4.svg";